// Libraries
import _ from 'lodash';

// App
import UpdateJobTypeForJobForm from '@shared/modules/Project/forms/UpdateJobTypeForJobForm';

const _new = ({projectId}: {projectId: string}) => ({
  projectId,
  projectTypeId: null,
  isBillingReset: true,
  updateJobTypeForJobForms: [],
  // Private
  assignedToOrganizationId: null,
  billingLibraryId: null,
  projectTypeName: '',
});

const toForm = ({
  projectId,
  projectTypeId,
  isBillingReset,
  updateJobTypeForJobForms,

  // Private
  billingLibraryId,
  assignedToOrganizationId,
  projectTypeName,
}: any) => ({
  projectId,
  projectTypeId: _.toString(projectTypeId),
  isBillingReset,
  updateJobTypeForJobForms: updateJobTypeForJobForms.map((updateJobTypeForJobForm: any) =>
    UpdateJobTypeForJobForm.toForm(updateJobTypeForJobForm),
  ),

  // Private
  billingLibraryId: _.toString(billingLibraryId),
  assignedToOrganizationId: _.toString(assignedToOrganizationId),
  projectTypeName,
});

const toMutation = ({projectId, projectTypeId, isBillingReset, updateJobTypeForJobForms}: any) => ({
  projectId,
  projectTypeId,
  isBillingReset,
  updateJobTypeForJobForms: updateJobTypeForJobForms.map((updateJobTypeForJobForm: any) =>
    UpdateJobTypeForJobForm.toMutation(updateJobTypeForJobForm),
  ),
});

const TransferProjectToOrganizationForm = {
  new: _new,
  toForm,
  toMutation,
};

export default TransferProjectToOrganizationForm;
